// UPC-A (GTIN-12) encoder — pure functions, no DOM. Drawing lives in
// get-labels-components/Barcodes.js. All GTINs in our DB are 12-digit UPC-A.

const L = ['0001101', '0011001', '0010011', '0111101', '0100011', '0110001', '0101111', '0111011', '0110111', '0001011'];
const R = L.map((c) => c.replace(/[01]/g, (b) => (b === '0' ? '1' : '0')));

// Trims whitespace; a 13-digit value with a leading 0 is the EAN-13 form of a UPC-A.
export function normalizeGtin(raw) {
  const v = String(raw ?? '').replace(/\s+/g, '');
  return /^0\d{12}$/.test(v) ? v.slice(1) : v;
}

export function upcaCheckDigit(digits) {
  let sum = 0;
  for (let i = 0; i < 11; i++) sum += (i % 2 === 0 ? 3 : 1) * Number(digits[i]);
  return (10 - (sum % 10)) % 10;
}

export function isValidUpca(s) {
  return /^\d{12}$/.test(s) && upcaCheckDigit(s) === Number(s[11]);
}

// 95 modules: start guard, 6 L-coded digits, center guard, 6 R-coded digits, end guard.
export function upcaModules(s) {
  const left  = [...s.slice(0, 6)].map((d) => L[d]).join('');
  const right = [...s.slice(6)].map((d) => R[d]).join('');
  return `101${left}01010${right}101`;
}
